import { FC } from 'react'
import { flushSync } from 'react-dom'
import type { LeadProfileLead } from '../../LeadProfileModal.types'
import { UserAddOutlined, UserDeleteOutlined } from '@ant-design/icons'
import classes from './index.module.css'
import { handlerDeleteStudAccount } from './deleteStudAccountModalFn'
import { useAddAlert } from '@/hooks/useAddAlert'
import { useFullLeadModalAccess } from '../../hooks/useFullLeadModalAccess'
import { useLeadRefetch } from '../../LeadRefetchContext'
import Button from '@UI/New/Button'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'

interface TabBindingStudAccountProps {
  lead: LeadProfileLead
  onOpenStudentAccount: () => void
  onOpenAddStudAccount: () => void
  onRefetchLead: () => void
}

const TabBindingStudAccount: FC<TabBindingStudAccountProps> = ({
  lead,
  onOpenStudentAccount,
  onOpenAddStudAccount,
  onRefetchLead,
}) => {
  const addAlert = useAddAlert()
  const access = useFullLeadModalAccess()
  const { patchLead } = useLeadRefetch()

  if (lead?.user_id) {
    return (
      <div className={classes.studAccountTabWrapper}>
        <div
          className={classes.boundActions}
          role="group"
          aria-label="Личный кабинет ученика"
        >
          <Button
            type="button"
            color="primary"
            className={classes.goToLkButton}
            onClick={() => onOpenStudentAccount()}
          >
            Перейти в ЛК ученика
          </Button>
          {access.canBindUnbindStudent && (
            <TooltipWrapper title="Отвязать ЛК ученика" placement="top">
              <Button
                type="button"
                color="danger"
                className={classes.unbindIconButton}
                classNames={{ button: classes.unbindIconButtonInner }}
                aria-label="Отвязать личный кабинет ученика"
                leftContent={
                  <UserDeleteOutlined
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                }
                onClick={() =>
                  handlerDeleteStudAccount({
                    lead,
                    addAlert,
                    onSuccess: ({ detachParents }) => {
                      flushSync(() => {
                        patchLead({
                          user_id: null,
                          user: null,
                          ...(detachParents ? { parents: [] } : {}),
                        })
                      })
                      onRefetchLead()
                    },
                  })
                }
              />
            </TooltipWrapper>
          )}
        </div>
      </div>
    )
  }

  if (!access.canBindUnbindStudent) {
    return null
  }

  return (
    <div className={classes.studAccountTabWrapper}>
      <Button
        type="button"
        color="primary"
        leftContent={
          <UserAddOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        }
        className={classes.bindLkButton}
        onClick={() => onOpenAddStudAccount()}
      >
        Привязать ЛК студента
      </Button>
    </div>
  )
}

export default TabBindingStudAccount
